import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Pagination, PaginationContent, PaginationEllipsis, PaginationItem, PaginationLink, PaginationNext, PaginationPrevious, } from "@/components/ui/pagination";
export function CatalogPagination({ currentPage, totalPages, onPageChange, }) {
    if (totalPages <= 1)
        return null;
    const getPageNumbers = () => {
        const pages = [];
        if (totalPages <= 7) {
            // Show all pages if 7 or fewer
            for (let i = 1; i <= totalPages; i++) {
                pages.push(i);
            }
        }
        else {
            // Always show first page
            pages.push(1);
            if (currentPage > 3) {
                pages.push("ellipsis");
            }
            // Show pages around current page
            const start = Math.max(2, currentPage - 1);
            const end = Math.min(totalPages - 1, currentPage + 1);
            for (let i = start; i <= end; i++) {
                pages.push(i);
            }
            if (currentPage < totalPages - 2) {
                pages.push("ellipsis");
            }
            // Always show last page
            pages.push(totalPages);
        }
        return pages;
    };
    return (_jsx(Pagination, { className: "mt-8", children: _jsxs(PaginationContent, { children: [_jsx(PaginationItem, { children: _jsx(PaginationPrevious, { onClick: () => currentPage > 1 && onPageChange(currentPage - 1), className: currentPage === 1
                            ? "pointer-events-none opacity-50"
                            : "cursor-pointer hover:bg-[#c85a3f]/10" }) }), getPageNumbers().map((page, index) => (_jsx(PaginationItem, { children: page === "ellipsis" ? (_jsx(PaginationEllipsis, {})) : (_jsx(PaginationLink, { onClick: () => onPageChange(page), isActive: currentPage === page, className: currentPage === page
                            ? "bg-[#c85a3f] text-white hover:bg-[#c85a3f]/90"
                            : "hover:bg-[#c85a3f]/10 cursor-pointer", children: page })) }, index))), _jsx(PaginationItem, { children: _jsx(PaginationNext, { onClick: () => currentPage < totalPages && onPageChange(currentPage + 1), className: currentPage === totalPages
                            ? "pointer-events-none opacity-50"
                            : "cursor-pointer hover:bg-[#c85a3f]/10" }) })] }) }));
}
